import * as React from 'react';

function SvgCilEthernet(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M18.053 5.54l-1.184.921 4.306 5.537-4.309 5.542 1.184.921 5.025-6.463-5.022-6.458zm-12.437 0L.591 12l5.022 6.461 1.184-.921L2.491 12 6.8 6.461 5.616 5.54zM7.5 11.25H9v1.5H7.5v-1.5zm3.75 0h1.5v1.5h-1.5v-1.5zm3.75 0h1.5v1.5H15v-1.5z" />
    </svg>
  );
}

export default SvgCilEthernet;
